import PagesMaintenance from "pages/Utility/pages-maintenance";

const UserWallets = () => {
  return (
    <PagesMaintenance />
  );
};

export default UserWallets;
